import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { PersistConfig, persistReducer } from 'redux-persist';

import db from 'modules/localForage/db';
import { setUser } from './actions';
import { User } from '../types';

const data = createReducer(null as User | null, (builder) => {
  builder.addCase(setUser, (_, action) => action.payload);
});

const hasLoaded = createReducer(false, (builder) => {
  builder.addCase(setUser, () => true);
});

const reducer = combineReducers({
  data,
  hasLoaded,
});

const userReducerConfig: PersistConfig<ReturnType<typeof reducer>> = {
  key: 'user',
  storage: db.app,
  whitelist: ['data'],
};

export const userReducer = persistReducer(userReducerConfig, reducer);
